/*jshint esversion: 9 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";

import TextField from "@material-ui/core/TextField";

// add dialog
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import store from "../../../components/stores/Store";
import { updateMarket, deleteMarket } from "../../../db/MarketRequestHandler";
// import { CheckSomething } from '../../../utils/CheckSomething';
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";
import CheckHandler from "../../../utils/CheckHandler";
import { updateLocalStorageFields } from '../../../utils/LocalStorageHandler';

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    // marginBottom: theme.spacing(2),
  },
  tableContainer: {
    maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
};

class TableOfMarketManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      updateDialogOpen: false,
      updateDialogParams: {
        ID: "",
        IDMsg: "",
        marketName: "",
        marketNameMsg: "",
        remark: "",
        remarkMsg: "",
      },
    };
    this.deleteLine = this.deleteLine.bind(this);
    this.updateLine = this.updateLine.bind(this);
    this.onDialogParamChange = this.onDialogParamChange.bind(this);
    this.changeMarket = this.changeMarket.bind(this);
    this.openUpdateDialog = this.openUpdateDialog.bind(this);
  }

  async componentDidMount() { }
  componentWillUnmount() { }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      },
    });
  }

  async deleteLine(e, id) {
    console.log(`----- send req of deleteMarket`);
    const rst = await deleteMarket({ ID: id });
    console.log(`----- rst of deleteMarket: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ updateDialogOpen: false });
      store.search();
      return true;
    }
  }

  onDialogParamChange(e, prop) {
    e.stopPropagation();
    const text = e.target.value;
    const newUpdateDialogParams = this.state.updateDialogParams;
    if (prop === "marketName") {
      const msg = text.trim().length === 0 ? "市场名称不能为空" : "";
      newUpdateDialogParams[`${prop}Msg`] = msg;
    } else if (prop === "remark") {
    }

    newUpdateDialogParams[prop] = text;
    e.stopPropagation();
    this.setState({ updateDialogParams: newUpdateDialogParams });
  }

  async updateLine() {
    const ID = this.state.updateDialogParams.ID.trim();
    const marketName = this.state.updateDialogParams.marketName.trim();
    const remark = (this.state.updateDialogParams.remark || '').trim();

    const chkRst = CheckHandler.checkParams([
      { key: "市场ID", value: ID, notNull: true, type: "int", maxLength: 4 },
      {
        key: "市场名称",
        value: marketName,
        notNull: true,
        type: "",
        maxLength: 20,
      },
      { key: "", value: remark, notNull: false, type: "", maxLength: 20 },
    ]);
    const msg = chkRst.msg;

    if (msg) {
      store.openMessageDialogOpen(msg);
      return;
    }

    console.log(
      `----- send req of  updateMarket: `,
      this.state.updateDialogParams
    );
    const rst = await updateMarket({ ID, marketName, remark });
    console.log(`----- rst of updateMarket: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "删除成功");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ updateDialogOpen: false });
      store.search();
      return true;
    }
  }

  changeMarket(id, marketName) {
    store.setMarketId(id);
    updateLocalStorageFields({ marketId: id, });
    store.openMessageDialogOpen(`切换成[${marketName}]市场`);
  }

  openUpdateDialog(row) {
    this.setState({
      updateDialogOpen: true,
      updateDialogParams: {
        ID: row.ID,
        IDMsg: "",
        marketName: row.marketName,
        marketNameMsg: "",
        remark: row.remark,
        remarkMsg: "",
      },
    });
  }

  render() {
    const { classes } = this.props;
    const headCells = [
      { id: "ID", align: "right", label: "市场ID" },
      {
        id: "marketName",
        align: "right",
        label: "市场名称",
      },
      { id: "remark", align: "right", label: "备注" },
      { id: "action", align: "center", label: "操作" },
    ];

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id="TableOfMarket"
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                    >
                      <TableSortLabel hideSortIcon>
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {store.table.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow hover tabIndex={-1} id={row.ID} key={row.ID}>
                      <TableCell
                        component="th"
                        align="right"
                        id={labelId}
                        scope="row"
                      >
                        {row.ID}
                      </TableCell>
                      <TableCell align="right">{row.marketName}</TableCell>
                      <TableCell align="right">{row.remark}</TableCell>
                      <TableCell align="center" style={{ width: "400px" }}>
                        <ButtonGroup variant="contained" aria-label="">
                          {getIfFuncAuthorized("系统管理-市场管理-修改") && (
                            <Button
                              color="primary"
                              style={{ width: "200px" }}
                              onClick={(e) => this.openUpdateDialog(row)}
                            >
                              修改
                            </Button>
                          )}
                          {store.marketId === row.ID && (
                            <Button style={{ width: "200px" }} disabled>
                              当前市场
                            </Button>
                          )}
                          {store.marketId !== row.ID && getIfFuncAuthorized("系统管理-市场管理-切换市场") && (
                            <Button
                              style={{ width: "200px" }}
                              onClick={(e) =>
                                this.changeMarket(row.ID, row.marketName)
                              }
                              color="secondary"
                            >
                              切换此市场
                            </Button>
                          )}
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.updateDialogOpen}
          onClose={(e) => this.setState({ updateDialogOpen: false })}
        >
          <DialogTitle id="form-dialog-title" style={{ width: "300px" }}>
            修改市场信息
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="市场ID"
              type="number"
              fullWidth
              disabled
              value={this.state.updateDialogParams.ID}
            />
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="市场名称"
              type="text"
              fullWidth
              error={this.state.updateDialogParams.marketNameMsg !== ""}
              helperText={this.state.updateDialogParams.marketNameMsg}
              value={this.state.updateDialogParams.marketName}
              onChange={(e) => this.onDialogParamChange(e, "marketName")}
            />
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="备注"
              type="text"
              fullWidth
              error={this.state.updateDialogParams.remarkMsg !== ""}
              helperText={this.state.updateDialogParams.remarkMsg}
              value={this.state.updateDialogParams.remark}
              onChange={(e) => this.onDialogParamChange(e, "remark")}
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              onClick={this.updateLine}
            >
              确认修改
            </Button>
            <Button
              onClick={(e) => this.setState({ updateDialogOpen: false })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfMarketManagement = observer(TableOfMarketManagementInner);

TableOfMarketManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfMarketManagement);
